export default {"src":"/_next/static/media/plus.3095dd26.svg","height":10,"width":10};